export const LanguageMenuENUSTranslations = {
  languageMenuSelectButtonLabel: 'Button to select language',
  languageMenuPortugueseButtonLabel: 'Button to select portuguese',
  languageMenuEnglishButtonLabel: 'Button to select english',
  languageMenuSelectedFlagImageAlt: 'Selected language flag',
  languageMenuBrasilFlagImageAlt: "Brazil's flag (portuguese language)",
  languageMenuUSAFlagImageAlt:
    'United State of America flag (english language)',
};
